import styled, { keyframes } from "styled-components";

interface Partner {
  src: string;
  alt: string;
  href: string;
}

const PARTNERS: Partner[] = [
  { src: "/img/logo/ATLASLOGO1.png", alt: "ATLAS", href: "/" },
  { src: "/img/logo/CCRDPLOGO.png", alt: "CCRDP", href: "https://www.ccrdp.org/" },
  { src: "/img/logo/SUBLOGO.png", alt: "BePath", href: "/" },
  { src: "/img/logo/SNUHLOGO.png", alt: "SNUH", href: "https://snuh.org/" },
  { src: "/img/logo/snubh.png", alt: "SNUBH", href: "https://www.snubh.org/index.do" },
  { src: "/img/logo/kumc.png", alt: "KUMC", href: "https://guro.kumc.or.kr/kr/index.do" },
  { src: "/img/logo/ncc.png", alt: "NCC", href: "https://www.ncc.re.kr/index" },
  { src: "/img/logo/samsunghospital.png", alt: "SMC", href: "https://www.samsunghospital.com/home/main/index.do" },
  { src: "/img/logo/cbnuh.png", alt: "CBNUH", href: "https://www.cbnuh.or.kr/main/index.do" },
  { src: "/img/logo/severance.png", alt: "Severance", href: "https://sev.severance.healthcare/sev/index.do" },
  { src: "/img/logo/cmcbucheon.png", alt: "CMC Bucheon", href: "https://www.cmcbucheon.or.kr/page/main" },
  { src: "/img/logo/kcch.png", alt: "KCCH", href: "https://www.kcch.re.kr/" },
  { src: "/img/logo/hallahosp.png", alt: "Halla Hospital", href: "https://www.hallahosp.co.kr/" },
  { src: "/img/logo/haeundae_paik.png", alt: "Haeundae Paik Hospital", href: "https://www.paik.ac.kr/haeundae/user/main/view.do" },
  { src: "/img/logo/paik.png", alt: "Ilsan Paik Hospital", href: "https://www.paik.ac.kr/ilsan/user/main/view.do" },
  { src: "/img/logo/asan.png", alt: "ASAN", href: "https://www.amc.seoul.kr/asan/main.do" },
];

const PartnerCarousel = () => {
  // 끊김 없는 무한 루프를 위해 목록을 두 번 이어붙임
  const loopItems = [...PARTNERS, ...PARTNERS];

  return (
    <Section>
      <Inner>
        <Heading>With Us</Heading>
        <Viewport>
          <Track>
            {loopItems.map((partner, idx) => (
              <LogoBox
                key={`${partner.alt}-${idx}`}
                href={partner.href}
                target={partner.href.startsWith("http") ? "_blank" : undefined}
                rel={partner.href.startsWith("http") ? "noopener noreferrer" : undefined}
                aria-label={partner.alt}
              >
                <img src={partner.src} alt={partner.alt} />
              </LogoBox>
            ))}
          </Track>
        </Viewport>
      </Inner>
    </Section>
  );
};

const marquee = keyframes`
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
`;

const Section = styled.section`
  width: 100%;
  padding: 60px 0 80px;
  background: #fcfdfe;
`;

const Inner = styled.div`
  max-width: 1800px;
  margin: 0 auto;
`;

const Heading = styled.h2`
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  color: #17375f;
  margin-bottom: 36px;
  letter-spacing: 0.02em;
`;

const Viewport = styled.div`
  position: relative;
  overflow: hidden;

  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0,
    #000 8%,
    #000 92%,
    transparent 100%
  );
  mask-image: linear-gradient(
    to right,
    transparent 0,
    #000 8%,
    #000 92%,
    transparent 100%
  );
`;

const Track = styled.div`
  display: flex;
  width: max-content;
  animation: ${marquee} 60s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

const LogoBox = styled.a`
  flex: 0 0 auto;
  width: 180px;
  height: 100px;
  margin: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  background: #fff;
  border: 1px solid #eef1f5;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;

  img {
    max-width: 100%;
    max-height: 52px;
    width: auto;
    object-fit: contain;
    /* filter: grayscale(100%); */
    /* opacity: 0.8; */
    transition: all 0.25s ease;
  }

  &:hover {
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
    transform: translateY(-3px);

    img {
      filter: grayscale(0%);
      opacity: 1;
    }
  }
`;

export default PartnerCarousel;
